/**
 * Represents types of audit events for roles.
 */
export enum RoleAuditEventTypeModel {
	/**
	 * A role was created.
	 */
	CreateRole = 1,
	/**
	 * An existing role was updated.
	 */
	UpdateRole = 2
}
